import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  callAddCustomer,
  callCreateCustomerObject,
  callDeleteCustomerObject,
  callDeleteCustomerVoucher,
  callDownloadImages,
  callEditCustomer,
  callGetCustomerDetail,
  callGetCustomerObject,
  callGetCustomerObjectById,
  callGetCustomerVoucherOverview,
  callGetCustomers,
  callUpdateCustomerObject
} from 'helpers/api_helper';
import { getAllImagesFromObjects, replaceImagesJson } from 'helpers/utils';

const toTotal = (response: any) => Number(response?.headers?.['x-total-count'] || 0);

export const getCustomers = createAsyncThunk(
  'customers/callGetCustomers',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetCustomers(param);
      return {
        data: response?.data,
        total: toTotal(response),
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCustomerDetail = createAsyncThunk(
  'customers/getCustomerDetail',
  async (id: string | number, { rejectWithValue }) => {
    try {
      const response = await callGetCustomerDetail(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const addCustomer = createAsyncThunk(
  'customers/addCustomer',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callAddCustomer(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const editCustomer = createAsyncThunk(
  'customers/editCustomer',
  async ({ id, param }: any, { rejectWithValue }) => {
    try {
      const response = await callEditCustomer(id, param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCustomerObject = createAsyncThunk(
  'customers/getCustomerObject',
  async (param: any, { rejectWithValue }) => {
    try {
      if (param.isActive === null || param.isActive === undefined) {
        param.isActive = null;
      }
      const response: any = await callGetCustomerObject(param);
      const customers: any[] = Array.isArray(response?.data) ? response.data : [];
      let data = customers;

      if (customers.length) {
        const images = getAllImagesFromObjects(customers);

        if (!images.length) {
          return {
            data,
            total: toTotal(response),
          };
        }
        const s3Images: any = await callDownloadImages({ storagePaths: images });
        if (s3Images.length) {
          const urls = s3Images.map((item: any) => item.url);
          data = replaceImagesJson(customers, urls);
        }
      }

      return {
        data,
        total: toTotal(response),
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCustomerObjectById = createAsyncThunk(
  'customers/callGetCustomerObjectById',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await callGetCustomerObjectById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const createCustomerObject = createAsyncThunk(
  'customers/callCreateCustomerObject',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callCreateCustomerObject(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const updateCustomerObject = createAsyncThunk(
  'customers/callUpdateCustomerObject',
  async (param: any, { rejectWithValue }) => {
    try {
      const response = await callUpdateCustomerObject(param);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteCustomerObject = createAsyncThunk(
  'customers/getCustomerObject',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await callDeleteCustomerObject(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const deleteCustomerVoucher = createAsyncThunk(
  'customers/callDeleteCustomerVoucher',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await callDeleteCustomerVoucher(id);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const getCustomerVoucherOverview = createAsyncThunk(
  'customers/callGetCustomerVoucherOverview',
  async (param: any, { rejectWithValue }) => {
    try {
      const response: any = await callGetCustomerVoucherOverview(param);
      return {
        data: Array.isArray(response?.data) ? response.data : [],
        total: toTotal(response),
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);
